/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
  mdiBookOpenVariant,
  mdiBookOpenPageVariant,
  mdiSoccer
} from '@mdi/js'

export default [
  {
    to: '/home-module',
    label: 'sidebarFin.addOn',
    // label: 'Add On',
    icon: mdiBookOpenVariant
  },
  {
    to: '/subject-selection',
    label: 'sidebarFin.subjectSelection',
    // label: 'Subject Selection',
    icon: mdiBookOpenPageVariant
  },
  {
    to: '/interest-selection',
    label: 'sidebarFin.interestClubSelection',
    // label: 'Interest Club Selection',
    icon: mdiSoccer
  }
]
